export default __webpack_public_path__ + "img/02467f8d61bffc5bb0ee0357dfd6826a.svg";